import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { ReadOnlyBlock } from '@blumtechgroup/blum-react-core-components';
import { useQuery } from '@apollo/client';
import { selectOrganisationUserInitQuery, OrganisationUser } from './queries';
import { StringUtils } from '@blumtechgroup/blum-ui-utils';

interface Props {
  userId: string;
  handleEdit: () => void;
}

const ViewOrganisationUsersComponent = ({ userId, handleEdit }: Props): React.ReactElement => {
  const [user, setUser] = useState<OrganisationUser>({
    first_name: '',
    last_name: '',
    email: '',
    active: true,
  });
  const { data: organisationUserInitData } = useQuery(selectOrganisationUserInitQuery(userId), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (organisationUserInitData) {
      setUser(organisationUserInitData.users_organisation_admin_by_pk);
    }
  }, [organisationUserInitData]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={4}>
        <ReadOnlyBlock
          items={[
            { label: 'Full Name', value: StringUtils.stringFromArray([user.first_name, user.last_name]) },
            { label: 'Email', value: user.email },
            { label: 'Active', value: StringUtils.booleanToYesNo(user.active) },
          ]}
          handleEdit={handleEdit}
        />
      </Grid>
    </Grid>
  );
};

export default ViewOrganisationUsersComponent;
